module.exports = __webpack_public_path__ + "static/wand_of_fear-7c2bf7304b184fff2899175855c1f2cd.jpeg";